const fhDrugs = [{
  'grouping': 'Statin',
  'value': {
    'drugsInGroup': [{
      'drug': 'Atorvastatin (Atorbir, Lipitor, Lipistad)',
      'dosages': [{
        'doseAmount': '10',
        'doseUnit': 'mg',
        'reductionInMmolL': 1.79,
        'reductionInPercentage': 37,
        'correctionFactor': 1.59
      },
      {
        'doseAmount': '20',
        'doseUnit': 'mg',
        'reductionInMmolL': 2.07,
        'reductionInPercentage': 43,
        'correctionFactor': 1.75
      },
      {
        'doseAmount': '40',
        'doseUnit': 'mg',
        'reductionInMmolL': 2.36,
        'reductionInPercentage': 49,
        'correctionFactor': 1.96
      },
      {
        'doseAmount': '80',
        'doseUnit': 'mg',
        'reductionInMmolL': 2.64,
        'reductionInPercentage': 55,
        'correctionFactor': 2.22
      }],
      'grouping': 'Statin',
      'frequency': 'day'
    },
    {
      'drug': 'Pravastatin',
      'dosages': [{
        'doseAmount': '20',
        'doseUnit': 'mg',
        'reductionInMmolL': 1.17,
        'reductionInPercentage': 24,
        'correctionFactor': 1.32
      },
      {
        'doseAmount': '40',
        'doseUnit': 'mg',
        'reductionInMmolL': 1.38,
        'reductionInPercentage': 39,
        'correctionFactor': 1.64
      }],
      'grouping': 'Statin',
      'frequency': 'day'
    },
    {
      'drug': 'Rosuvastatin (Crestor)',
      'dosages': [{
        'doseAmount': '5',
        'doseUnit': 'mg',
        'reductionInMmolL': 1.84,
        'reductionInPercentage': 38,
        'correctionFactor': 1.61
      },
      {
        'doseAmount': '10',
        'doseUnit': 'mg',
        'reductionInMmolL': 2.08,
        'reductionInPercentage': 43,
        'correctionFactor': 1.75
      },
      {
        'doseAmount': '20',
        'doseUnit': 'mg',
        'reductionInMmolL': 2.32,
        'reductionInPercentage': 48,
        'correctionFactor': 1.92
      },
      {
        'doseAmount': '40',
        'doseUnit': 'mg',
        'reductionInMmolL': 2.56,
        'reductionInPercentage': 53,
        'correctionFactor': 2.13
      }],
      'grouping': 'Statin',
      'frequency': 'day'
    },
    {
      'drug': 'Simvastatin (Simidon, Zocord)',
      'dosages': [{
        'doseAmount': '10',
        'doseUnit': 'mg',
        'reductionInMmolL': 1.31,
        'reductionInPercentage': 27,
        'correctionFactor': 1.37
      },
      {
        'doseAmount': '20',
        'doseUnit': 'mg',
        'reductionInMmolL': 1.54,
        'reductionInPercentage': 32,
        'correctionFactor': 1.47
      },
      {
        'doseAmount': '40',
        'doseUnit': 'mg',
        'reductionInMmolL': 1.78,
        'reductionInPercentage': 37,
        'correctionFactor': 1.59
      },
      {
        'doseAmount': '80',
        'doseUnit': 'mg',
        'reductionInMmolL': 2.01,
        'reductionInPercentage': 42,
        'correctionFactor': 1.72
      }],
      'grouping': 'Statin',
      'frequency': 'day'
    }],
    'selectedDrug': '',
    'selectedDosage': ''
  }
},
{
  'grouping': 'Ezetimib',
  'value': {
    'drugsInGroup': [{
      'drug': 'Ezetemib (Ezetrol)',
      'dosages': [{
        'doseAmount': '10',
        'doseUnit': 'mg',
        'reductionInMmolL': -1,
        'reductionInPercentage': 19,
        'correctionFactor': 1.23
      }],
      'grouping': 'Ezetimib',
      'frequency': 'day'
    }],
    'selectedDrug': '',
    'selectedDosage': ''
  }
},
{
  'grouping': 'PCSK9-hämmare',
  'value': {
    'drugsInGroup': [{
      'drug': 'Alirocumab (Praluent)',
      'dosages': [{
        'doseAmount': '75',
        'doseUnit': 'mg',
        'reductionInMmolL': 0.57,
        'reductionInPercentage': 55,
        'correctionFactor': 2.2
      },
      {
        'doseAmount': '150',
        'doseUnit': 'mg',
        'reductionInMmolL': 0.57,
        'reductionInPercentage': 55,
        'correctionFactor': 2.2
      }],
      'grouping': 'PCSK9-hämmare',
      'frequency': 'byWeekly'
    },
    {
      'drug': 'Evolucumab (Repatha)',
      'dosages': [{
        'doseAmount': '140',
        'doseUnit': 'mg',
        'reductionInMmolL': 0.57,
        'reductionInPercentage': 55,
        'correctionFactor': 2.2
      }],
      'grouping': 'PCSK9-hämmare',
      'frequency': 'byWeekly'
    },
    {
      'drug': 'Inklisiran (Leqvio)',
      'dosages': [{
        'doseAmount': '284',
        'doseUnit': 'mg',
        'reductionInMmolL': 0.57,
        'reductionInPercentage': 55,
        'correctionFactor': 2.2
      }],
      'grouping': 'PCSK9-hämmare',
      'frequency': 'byWeekly'
    }],
    'selectedDrug': '',
    'selectedDosage': ''
  }
}]
export {
  fhDrugs
}



// WEBPACK FOOTER //
// ./src/plugins/fhdrugs.js